import { render, staticRenderFns } from "./BoxStatus.vue?vue&type=template&id=b9a83db4&scoped=true"
import script from "./BoxStatus.vue?vue&type=script&lang=js"
export * from "./BoxStatus.vue?vue&type=script&lang=js"
import style0 from "./BoxStatus.vue?vue&type=style&index=0&id=b9a83db4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9a83db4",
  null
  
)

export default component.exports